module.exports = __webpack_public_path__ + "img/1.71ec39b9.png";